/**
 * The "read-only" marker of a read-only connection (round B U32): the Object Explorer row, the Home / Connections card
 * and — since the A+B merge — every storage tab toolbar show the same muted tag with the same tooltip.
 */
import { READ_ONLY_CONNECTION_TITLE } from '../utils/connectionServerLine';

export function ReadOnlyConnectionBadge({ testId }: { testId: string }) {
  return (
    <span
      className="shrink-0 rounded bg-muted px-1 text-[10px] leading-4 text-muted-foreground"
      title={READ_ONLY_CONNECTION_TITLE}
      data-testid={testId}
    >
      read-only
    </span>
  );
}
